module.exports = __webpack_public_path__ + "static/media/img--2760x1246.1b689d0a.1b689d0a.jpg";